import { Map, List, fromJS } from 'immutable'
import createReucer from '@/models/createReucer'
import {

} from './actionTypes'

const initializeState = Map({
  entries: List(),
  fetching: false,
  total: 0
})

export default createReucer({

}, initializeState)
